<template>
  <div class="modal fade" id="become-affiliate-status-modal" tabindex="-1" role="dialog"
       aria-labelledby="affiliate-pending-modal">
    <div :class="['modal-dialog', {'zh-style': lang === 'zh'}]" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <button class="close" data-dismiss="modal">
            <span>
              <svg class="icon">
                <use xlink:href="#icon-close"></use>
              </svg>
            </span>
          </button>
        </div>
        <div class="modal-body">
          <p class="notice">
            <template v-if="commissionApplyStatus === 'pending'">{{ $t('pendingNotice') }}</template>
            <template v-if="commissionApplyStatus === 'cancelled'">{{ $t('cancelledNotice') }}</template>
            <template v-if="commissionApplyStatus === 'complete'">{{ $t('completeNotice') }}</template>
            <span class="email">iplexservice@gmail.com</span> .</p>
          <button data-dismiss="modal">{{ $t('sure') }}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import locales from './lang'
  import $ from 'jquery'

  export default {
    name: 'become-affiliate-status-modal',
    locales,
    computed: {
      lang() {
        return this.$store.state.currentLang
      },
      commissionApplyStatus() {
        return this.$store.state.commission.commissionApplyStatus
      }
    },
    mounted() {
      $('#become-affiliate-status-modal').modal('show')
    }
  }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  @import "../../../assets/scss/variables";
  @import "../../../assets/scss/mixins/button";
  @import "../../../assets/scss/reset-modal";

  .modal-dialog {
    @include modal-dialog($height: 2.94rem, $phone-height: 3.5rem);
    @media (max-width: 767px) {
      margin: calc(50vh - 1.75rem) 0 0 -45% !important;
    }
    &.zh-style {
      @include modal-dialog($height: 2.66rem, $phone-height: 2.94rem);
      @media (max-width: 767px) {
        margin: calc(50vh - 1.47rem) 0 0 -45% !important;
      }
    }
    .modal-content {
      padding: .2rem;
      text-align: center;
    }
  }

  .modal-body {
    .notice {
      padding: .2rem .2rem .6rem .2rem;
      font-size: .16rem;
      color: #333333;
      letter-spacing: 0.71px;
      line-height: .28rem;
      span.email {
        color: #416CF8;
      }
    }
    button {
      @include modal-button();
    }
  }
</style>



// WEBPACK FOOTER //
// Index.vue?47558a96